/* macarons-theme */
const theme = {
  "color": [
    "#2497f4",
    "#c581dc",
    "#8cc44a",
    "#79aff5",
    "#e13fab",
    "#e5694a",
    "#f76186",
    "#02968b",
    "#00adef",
    "#cbdd38",
    "#01bcd6",
    "#feea3d",
    "#fe9823",
    "#7d85e8",
    "#e4002c",
    "#59678c",
    "#fec108"
  ],
  "backgroundColor": "rgba(0,0,0,0)",
  "textStyle": {},
  "title": {
    "textStyle": {
      "color": "#c2c2c2"
    },
    "subtextStyle": {
      "color": "#d6d6d6"
    }
  },
  "line": {
    "itemStyle": {
      "normal": {
        "borderWidth": 1.5,
        "borderColor": "#fff"
      },
      "emphasis": {
        "borderWidth": 2,
        "borderColor": "#fff"
      }
    },
    "lineStyle": {
      "normal": {
        "width": 1.5,
        "opacity":0.5
      }
    },
    "symbolSize": 8,
    "symbol": "circle",
    "smooth": 0.2
  },
  "radar": {
    "itemStyle": {
      "normal": {
        "borderWidth": 1
      }
    },
    "lineStyle": {
      "normal": {
        "width": 1.5,
        "opacity":0.5
      }
    },
    "symbolSize": 6,
    "symbol": "emptyCircle",
    "smooth": 0.2
  },
  "bar": {
    "itemStyle": {
      "normal": {
        "barBorderWidth": 0,
        "barBorderColor": "#ccc"
      },
      "emphasis": {
        "barBorderWidth": 0,
        "barBorderColor": "#ccc"
      }
    }
  },
  "pie": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "scatter": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "boxplot": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "parallel": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "sankey": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "funnel": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "gauge": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "emphasis": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    }
  },
  "candlestick": {
    "itemStyle": {
      "normal": {
        "color": "#d87a80",
        "color0": "#2ec7c9",
        "borderColor": "#d87a80",
        "borderColor0": "#2ec7c9",
        "borderWidth": 1
      }
    }
  },
  "graph": {
    "itemStyle": {
      "normal": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "lineStyle": {
      "normal": {
        "width": 1,
        "color": "#aaaaaa"
      }
    },
    "symbolSize": 3,
    "symbol": "emptyCircle",
    "smooth": 0.2,
    "label": {
      "normal": {
        "textStyle": {
          "color": "#eeeeee"
        }
      }
    }
  },
  "map": {
    "itemStyle": {
      "normal": {
        "areaColor": "#dddddd",
        "borderColor": "#eeeeee",
        "borderWidth": 0.5
      },
      "emphasis": {
        "areaColor": "rgba(254,153,78,1)",
        "borderColor": "#444444",
        "borderWidth": 1
      }
    },
    "label": {
      "normal": {
        "textStyle": {
          "color": "#d87a80"
        }
      },
      "emphasis": {
        "textStyle": {
          "color": "rgb(100,0,0)"
        }
      }
    }
  },
  "geo": {
    "itemStyle": {
      "normal": {
        "areaColor": "#dddddd",
        "borderColor": "#eeeeee",
        "borderWidth": 0.5
      },
      "emphasis": {
        "areaColor": "rgba(254,153,78,1)",
        "borderColor": "#444444",
        "borderWidth": 1
      }
    },
    "label": {
      "normal": {
        "textStyle": {
          "color": "#d87a80"
        }
      },
      "emphasis": {
        "textStyle": {
          "color": "rgb(100,0,0)"
        }
      }
    }
  },
  "categoryAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#d9dde1"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#ccc"
      }
    },
    "axisLabel": {
      "show": true,
      "textStyle": {
        "color": "#888"
      }
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": [
          "#eee"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(250,250,250,0.1)",
          "rgba(200,200,200,0.1)"
        ]
      }
    }
  },
  "valueAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#d9dde1"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#ccc"
      }
    },
    "axisLabel": {
      "show": true,
      "textStyle": {
        "color": "#888"
      }
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": [
          "#f7f7f7"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(250,250,250,0.1)",
          "rgba(200,200,200,0.1)"
        ]
      }
    }
  },
  "logAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#d9dde1"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#888"
      }
    },
    "axisLabel": {
      "show": true,
      "textStyle": {
        "color": "#888"
      }
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": [
          "#eee"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(250,250,250,0.1)",
          "rgba(200,200,200,0.1)"
        ]
      }
    }
  },
  "timeAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#d9dde1"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#ccc"
      }
    },
    "axisLabel": {
      "show": true,
      "textStyle": {
        "color": "#888"
      }
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": [
          "#eee"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(250,250,250,0.1)",
          "rgba(200,200,200,0.1)"
        ]
      }
    }
  },
  "toolbox": {
    "iconStyle": {
      "normal": {
        "borderColor": "#2ec7c9"
      },
      "emphasis": {
        "borderColor": "#18a4a6"
      }
    }
  },
  "legend": {
    "textStyle": {
      "color": "#333333"
    }
  },
  "tooltip": {
    trigger: 'axis',
    "confine": true,
    "axisPointer": {
      "lineStyle": {
        "color": "#dcdee3",
        "width": "1"
      },
      "crossStyle": {
        "color": "#dcdee3",
        "width": "1"
      }
    },
    "textStyle":{
      "fontSize":12
    }
  },
  "timeline": {
    "lineStyle": {
      "color": "#dcdee3",
      "width": 1
    },
    "itemStyle": {
      "normal": {
        "color": "#dcdee3",
        "borderWidth": 1
      },
      "emphasis": {
        "color": "#1a83ff"
      }
    },
    "controlStyle": {
      "normal": {
        "color": "#d09309",
        "borderColor": "#d09309",
        "borderWidth": 0.5
      },
      "emphasis": {
        "color": "#d09309",
        "borderColor": "#d09309",
        "borderWidth": 0.5
      }
    },
    "checkpointStyle": {
      "color": "#2ec7c9",
      "borderColor": "rgba(46,199,201,0.4)"
    },
    "label": {
      "normal": {
        "textStyle": {
          "color": "#008acd"
        }
      },
      "emphasis": {
        "textStyle": {
          "color": "#008acd"
        }
      }
    }
  },
  "visualMap": {
    "color": [
      "#00a94e",
      "#e0ffff"
    ]
  },
  "dataZoom": {
    "backgroundColor": "rgba(47,69,84,0)",
    "dataBackgroundColor": "rgba(239,239,255,1)",
    "fillerColor": "rgba(182,162,222,0.2)",
    "handleColor": "#008acd",
    "handleSize": "100%",
    "textStyle": {
      "color": "#333333"
    }
  },
  "markPoint": {
    "label": {
      "normal": {
        "textStyle": {
          "color": "#eeeeee"
        }
      },
      "emphasis": {
        "textStyle": {
          "color": "#eeeeee"
        }
      }
    }
  }
};
export default theme
